<template>
    <div>
        <div class="d-flex flex-row mb-5 border-bottom">
            <div class="h4 flex-grow-1 d-flex  flex-column align-items-center justify-content-center" >
                <span class="mb-2">{{ objectDescription }}</span>
                <small class="text-secondary mb-2">{{ objectTitle }}</small>
            </div>

            <div class="d-flex">
                <div class="flex-grow-0">
                    <b-button variant="outline-secondary" size="lg" class="border-0 p-0" @click="onClose">
                        <b-icon icon="x" />
                    </b-button>
                </div>
            </div>
        </div>

        <div>
            <div class="mb-5 d-flex flex-column text-center">
                <span class="h5">Вы действительно хотите удалить этот объект?</span>
                <small class="text-secondary">Это действие будет невозможно отменить.</small>
            </div>
            <div class="d-flex">
                <div class="flex-grow-1"><b-button variant="secondary" @click="onClose">Отмена</b-button></div>
                <div class="flex-grow-0"><b-button variant="danger" @click="destroy"><b-icon icon="trash" class="mr-2" /><span>Удалить</span></b-button></div>
            </div>
        </div>
    </div>
</template>

<script>
import httpClient from "@/http";

export default {
    name: "DataTableDestroy",
    props: {
        object: { type: Object },
        apiEntryPoint: { type: Object }
    },
    computed: {
        objectTitle() { return this.object.label() },
        objectDescription() { return this.object.objectLabel() }
    },
    methods: {
        onClose() {
            this.$emit('close')
        },
        showError(message) {
            let messageText = message ? message : 'Не удалось удалить объект';
            this.$bvToast.toast(messageText, {
                noCloseButton: true,
                solid: true,
                autoHideDelay: 5000,
                variant: 'danger'
            });
        },
        destroy() {
            if (!this.object || !this.object.id || !this.apiEntryPoint) {
                this.showError();
                return;
            }
            const vm = this;
            const url  = this.apiEntryPoint.detail(this.object.id)
            httpClient.delete(url)
                .then((response) => {
                    vm.$emit('object-deleted')
                })
                .catch((reason) => {
                    let message = null;
                    if (reason.response && reason.response.data) {
                        message = reason.response.data['message']
                    }
                    vm.showError(message);
                })
        },

    }
}
</script>

<style scoped>

</style>